import { MeasureTime, PerformanceMonitoringService } from './types';

const appInitializedMark = 'app-initialized';

const toSeconds = (number: number) => Number((number / 1000).toPrecision(2));

const createPerformanceMonitoringService = (): PerformanceMonitoringService => {
    if (!window.newrelic) {
        throw new Error('New relic is required for perfomance monitoring but was not found on window object.');
    }

    const durationBeforeAppStarted = Number(window.performance.now().toPrecision(2));
    const appStartedTimeStamp = new Date().getTime();
    const calculateResources = () => {
        let totalTimeToDownloadResources = 0;
        const resources = window.performance.getEntriesByType('resource');
        resources.forEach((resource) => {
            const timeToDownload = resource.startTime > 0 ? (resource as $TSFixMe).responseEnd - resource.startTime : 0;
            totalTimeToDownloadResources += timeToDownload;
        });

        window.performance.clearResourceTimings();
        return totalTimeToDownloadResources;
    };

    const measureTimeSinceNavStarted = ({ markEnd, measureName }: MeasureTime) => {
        window.performance.measure(measureName, undefined, markEnd);
        const [entry] = window.performance.getEntriesByType('measure');

        const sessionTrace = {
            name: entry.name,
            start: appStartedTimeStamp,
            end: appStartedTimeStamp + entry.duration,
        };

        window.performance.clearMeasures();

        return { measureDuration: entry.duration, sessionTrace };
    };

    return {
        calculateResources,
        markAppStarted: () => {
            const timeToDownloadResources = calculateResources();

            window.newrelic.addPageAction('app-start-resources', {
                appStartedResourcesDuration: toSeconds(timeToDownloadResources),
            });
            window.newrelic.addPageAction('app-started', { appStartedDuration: toSeconds(durationBeforeAppStarted) });
        },
        mesuareAppInitializationTime: () => {
            window.performance.mark(appInitializedMark);
            const timeToDownloadResources = calculateResources();
            const appInit = measureTimeSinceNavStarted({
                markEnd: appInitializedMark,
                measureName: 'app-initialized',
            });

            window.newrelic.addPageAction('app-init-resources', {
                initialResourcesDuration: toSeconds(timeToDownloadResources),
            });
            window.newrelic.addToTrace(appInit.sessionTrace);
            window.newrelic.addPageAction('app-initialized', { appInitDuration: toSeconds(appInit.measureDuration) });
        },
    };
};

export default createPerformanceMonitoringService;
